import React, {useEffect, useState} from 'react'
import {useHistory, useParams} from "react-router-dom";
import DQRatedProgramView from "../../../views/ver_24.10/ProgramRating/DQRating/DQRatedProgram.view";
import {
    fetchRatingProgramStatusService,
} from "../../../services/rating.service";
import {APP_STATUS} from "../../../utils/constants";
import Loader from "../../../ui_library/ver_24.10/Loader/Loader.comp";

const DQRatedProgram = () => {
    const history = useHistory();
    const { programId } = useParams();
    const [showLoader, setShowLoader] = useState(false);
    const [programStatus, setProgramStatus] = useState(null);
    const [programStatusV3, setProgramStatusV3] = useState(null);
    const [fetching, setFetching] = useState(true);

    useEffect(() => {
        setShowLoader(true);

        const fetchProgramData = async () => {
            try {
                await fetchRatingProgram();
            } catch (error) {
                // Handle error if needed
                console.error('Error fetching program:', error);
            } finally {
                setShowLoader(false);
            }
        };

        fetchProgramData().then(r => console.log(r));

        const interval = setInterval(() => {
            if (fetching) {
                fetchProgramData();
            } else {
                clearInterval(interval);
            }
        }, 5000);

        return () => clearInterval(interval);
    }, [programId, fetching]);

    const fetchRatingProgram = async () => {
        const result = await fetchRatingProgramStatusService(programId);
        if (result.data && result.data) {
            setProgramStatus(result.data.app_status);
            setProgramStatusV3(result.data.app_status_v3)
            if (
                result.data.app_status_v3 === APP_STATUS.PROGRAM_FULL_REPORT_COMPLETED ||
                result.data.app_status_v3 === APP_STATUS.PROGRAM_SUMMARY_REPORT_COMPLETED ||
                result.data.app_status_v3 === APP_STATUS.PROGRAM_SUMMARY_REPORT_HALTED ||
                result.data.app_status === APP_STATUS.WITHDRAWN ||
                result.data.app_status === APP_STATUS.REJECTED ||
                result.data.app_status === APP_STATUS.HALTED_COLLECT_DATA ||
                result.data.app_status === APP_STATUS.HALTED_PROCESS_DATA ||
                result.data.app_status === APP_STATUS.HALTED_REPORT
            ) {
                setFetching(false);
            }
        }
    };
    const data = {
        programStatus,
        programStatusV3
    };

    // Actions handling business logic
    const actions = {
        ViewReportAction : async () => {
            setShowLoader(true);
            try {
                if (programStatusV3 >= APP_STATUS.PROGRAM_SUMMARY_REPORT_COMPLETED) {
                    history.push(`/dq_rating/${programId}/content_report`);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setShowLoader(false);
            }
        },
    };

    // Configuration options for visual appearance
    const options = {
    };

    if (showLoader) {
        return <Loader />;
    }

    return (
        <>
            <DQRatedProgramView
                data={data}
                actions={actions}
                options={options}
            />
        </>
    );
}

export default DQRatedProgram;